import { Component, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { Mode, Role } from '../../const';

export enum Tabs { 
  Package = "Package", 
  Module = "Module", 
  SubCategory = "Analytics Toolkit", 
  Metrics = "Metric" } 

@Component({
    selector: 'app-package-center',
    templateUrl: './package-center.component.html',
})
export class PackageCenterComponent implements OnInit {
  showForm: boolean = false;
  activeTab: string = Tabs.Package;
  tabs = Tabs;
  pageTitle: string = "";
  mode = Mode;
  hideGlobalCreate: boolean = false;
  userRole: string[] = [];
  roles = Role;

  ngOnInit(): void {
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
  }

  constructor(public dialog: MatDialog) {}

  setTabName(tabName: string){
    this.hideGlobalCreate = false;
    this.activeTab = tabName;
  }

  showCreateForm() {
    this.showForm = true;
  }

  closeCreateForm() {
    this.showForm = false;
    this.pageTitle = "";
  }

  setPageTitleTriggered(value: any){
    this.pageTitle = value.mode + ' ' + value.tab;
  }

  hideCreate(value: boolean){
    this.hideGlobalCreate = value;
  }
}
